module.exports = __webpack_public_path__ + "img/YV.90753d32.png";